'use client'
import React, { Component, ErrorInfo } from 'react'
import wretch from 'wretch'
import { UnexpectedError } from './UnexpectedError'

export class ErrorBoundary extends Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  constructor(props) {
    super(props)

    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    wretch().post(
      {
        componentStack: errorInfo?.componentStack,
        error: error.stack,
      },
      '/api/register/error'
    )
  }

  render() {
    if (this.state.hasError) {
      return <UnexpectedError />
    }

    // Return children components in case of no error

    return this.props.children
  }
}
